var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPower = function SvgPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6 3a1 1 0 1 0 0 2h3v1.6H8.4a2.8 2.8 0 0 0-2.8 2.8v2H4V7.6a1 1 0 1 0-2 0v9.6a1 1 0 1 0 2 0v-3.8h1.6v2a2.8 2.8 0 0 0 2.8 2.8h3.92l2.267 2.129a1 1 0 0 0 .685.271H19.2a2.8 2.8 0 0 0 2.8-2.8V9.4a2.8 2.8 0 0 0-2.8-2.8h-4.6V5h3.533a1 1 0 1 0 0-2H9.6Zm2.6 8a1 1 0 1 0-2 0v2.4a1 1 0 1 0 2 0V11Zm3.2 0a1 1 0 1 0-2 0v2.4a1 1 0 1 0 2 0V11Zm2.2-1a1 1 0 0 1 1 1v2.4a1 1 0 1 1-2 0V11a1 1 0 0 1 1-1Z",
    fill: "#F08200"
  })));
};
export default SvgPower;